var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"series-tile grid-item grid-item--width2",domProps:{"innerHTML":_vm._s(_vm.cleanedDesc)}})}
var staticRenderFns = []

export { render, staticRenderFns }